// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"Toggle_toggleContainer__kGEw6","toggle":"Toggle_toggle__zCZip"};